import { Outlet } from "react-router-dom";

export default function Auth() {
  return (
    <div className="min-h-screen bg-gray-100 flex flex-col justify-center sm:px-6 lg:px-8">
      <Outlet />
    </div>
  );
}
